import { isGlobalFeatureEnabled } from "owa-feature-flags";

// Check if Proactive Drafts feature is enabled
export function isProactiveDraftEnabled(): boolean {
    return (isGlobalFeatureEnabled("mon-copilot-proactive-drafts") ||
        isGlobalFeatureEnabled("mon-copilot-proactive-drafts-enableForAllEmails"));
}
